import React from 'react';

import styled from 'styled-components';
import { jUserLittle } from 'jamespot-user-api';
import { JRCAvatar } from 'components/JRCAvatar/JRCAvatar';
import { JRCTooltip } from 'components/JRCTooltip/JRCTooltip';

export const CSSAvatarList = styled.ul`
    list-style: none;
    display: flex;
`;

export const CSSAvatarListItem = styled.li<{ overlap?: boolean; small?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 32px;
    overflow: hidden;
    font-size: ${(props) => (props.small ? '12' : '14')}px;
    color: ${(props) => props.theme.color.white};
    background-color: ${(props) => props.theme.color.lavender};
    border: 4px solid ${(props) => props.theme.color.white};
    margin-left: ${(props) => (props.overlap ? '-18px' : '0')};
`;

export const WidgetAvatarList = ({ list, left }: { list: jUserLittle[]; left: number }) => {
    return (
        <CSSAvatarList>
            {list.map((user, index) => (
                <CSSAvatarListItem key={user.uri} overlap={index > 0}>
                    <JRCTooltip description={user.title} position="top">
                        <JRCAvatar uri={user.uri} size={3} variant="circle" alt="" />
                    </JRCTooltip>
                </CSSAvatarListItem>
            ))}
            {left !== 0 && (
                <CSSAvatarListItem overlap={true} small={true}>
                    <JRCTooltip description={`+${left}`} position="top">
                        +{left}
                    </JRCTooltip>
                </CSSAvatarListItem>
            )}
        </CSSAvatarList>
    );
};
